import { Container } from "@mui/material";
import React from "react";
import Hero from "../components/hero/Hero";
import Achievements from "../components/achievements/Achievements"
import VisionMission from "../components/vision-mission/VisionMission"

const desc = `Aspire Tax and Bookkeeping empowering individuals and businesses with clarity, compliance, and long-term financial 
success. We strive to redefine professional financial services through accuracy, innovation, and a client-first approach, ensuring 
every client feels supported, informed, and confident in their financial future, we prioritise personalised solutions, tailoring our 
Tax, Accounting, and Bookkeeping services to meet the unique needs of individuals, sole traders, and businesses across Australia.`;


function AboutUsPage() {
  return (
    <>
     <Hero 
        contentAlign='center'
        title="About Aspire Tax and Bookkeeping"
        titleAlign='center'
        subTitle="Empowering Australian Businesses with Accounting and Taxation Solutions"
        subTitleAlign='center'
        backgroundImage={'url(/assets/tax.jpg)'}
        
        primaryButton={{
        text: 'Book Now',
        className: 'hero-box__button',
        route:'/book-now',
        }}
        
        // secondayButton={{
        // text: 'Meet Our Team',
        // className: 'hero-box__transparentButton',
        // route: '#our-team',
        // }}
      />

      <Achievements
      title="Our Vision and Values" 
      titleColor="#0A0A7B" 
      description={desc}
      sideImage={'/assets/group-meeting.webp'}
      />
      
      {/* <div id="our-team" >
        <OurTeam />
      </div> */}
        
      <VisionMission/>
      
      <Container maxWidth="xl"></Container>
    </>
  );
}

export default AboutUsPage;
